import { render, staticRenderFns } from "./LessonTime.vue?vue&type=template&id=3552da91"
import script from "./LessonTime.vue?vue&type=script&lang=js"
export * from "./LessonTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3552da91')) {
      api.createRecord('3552da91', component.options)
    } else {
      api.reload('3552da91', component.options)
    }
    module.hot.accept("./LessonTime.vue?vue&type=template&id=3552da91", function () {
      api.rerender('3552da91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/LessonTime.vue"
export default component.exports